$(".city-field").each(function (i,el) {
    let cityOptions = $(".city-option")
    let cityToggle = $(el).find(".city-field__toggle")

    $(cityToggle).click(function () {
        $(el).toggleClass("_open")
    })

    $(cityOptions).click(function () {
        let flagSrc = $(this).attr("data-flag")
        let cityName = $(this).attr("data-city")

        $(el).find(".city-field__flag").attr("src",flagSrc)
        $(el).find(".city-field__field").val(cityName)

        $(el).removeClass("_open")
    })

    $(document).mouseup( function(e){
        let div = $(el);
        if ( !div.is(e.target)
            && div.has(e.target).length === 0 ) {
            if($(div).hasClass("_open")){
                $(div).removeClass("_open")
            }
        }
    });
})
